import type { ReactNode } from 'react'
import clsx from 'clsx'
import styles from './StatList.module.scss'

export interface StatListItem {
  key: ReactNode
  value: ReactNode
}

export interface StatListProps {
  items: StatListItem[]
  className?: string
}

/** Values longer than this get their own line under the label instead of fighting it for width. */
const LONG_VALUE = 28

/** Key/value rows for detail side panels. */
export function StatList({ items, className }: StatListProps) {
  return (
    <dl className={clsx(styles.statList, className)}>
      {items.map((item, i) => {
        const long = typeof item.value === 'string' && item.value.length > LONG_VALUE
        return (
          <div key={i} className={clsx(styles.statRow, long && styles.stacked)}>
            <dt className={styles.statKey}>{item.key}</dt>
            <dd className={styles.statValue} style={{ margin: 0 }}>
              {item.value}
            </dd>
          </div>
        )
      })}
    </dl>
  )
}
